module.exports = __webpack_public_path__ + "static/media/balloon3.7822dbcc.png";